<template>
  <div>
    <section class="flex gap-2 items-baseline">
      <i class="icon-food mr-1 text-gray-500 text-sm" />
      <span class="flex flex-grow flex-wrap gap-2 sm:gap-0 text-gray-500 text-sm">
        <span class="sm:min-w-[200px]">
          <displayed-time-format
            :period="order.receive_time"
            nowrap
            text-color-class="text-gray-500"
            text-size-class="text-sm"
            text-weight-class="font-normal"
            />
        </span>
        <span class="flex flex-nowrap">
          <span class="whitespace-nowrap">({{ isCancelled ? `取消時間` : `訂購時間` }}：</span>
          <displayed-time-format
            :period="isCancelled ? order.canceled_at : order.created_at"
            nowrap
            text-color-class="text-gray-500"
            text-size-class="text-sm"
            text-weight-class="font-normal"
          />
          <span>)</span>
        </span>
      </span>
      <span
        v-if="isCancelled"
        class="font-medium text-red-700 whitespace-nowrap"
      >
        訂單已取消
      </span>
      <span v-else>{{ total | commaFormat | priceFormat }}</span>
    </section>
    <section class="mt-2">
      <div class="flex justify-between">
        <ul>
          <li
            v-for="(content) in contents"
            :key="`item-${content.cart_index}`"
            :class="{ 'line-through': isCancelled }"
            class="text-sm"
          >
            <span class="flex gap-2 mb-2">
              <span class="min-w-[28px]">{{ content.quantity }}x</span>
              <span class="sm:max-w-[200px] max-w-[280px]">
                <p>{{ content.entree_name }}</p>
                <p class="mt-1 text-xs">{{ getOptionItemsText(content.options) }}</p>
                <p v-if="hasNote(content)" class="mt-1 text-xs">備註：{{ content.note }}</p>
              </span>
              <span v-if="!isCancelled">
                {{ content.entree_price | commaFormat | priceFormat}}
              </span>
            </span>
          </li>
        </ul>
        <div>
          <w-button
            v-if="!isCancelled"
            class="
              border-red-500
              disabled:bg-red-50
              disabled:border-red-50
              hover:text-white
              hover:bg-red-500
              px-2
              sm:flex-grow
              text-red-500
              text-xs
            "
            variant="outline"
            @click="onCancelBtnClick"
          >
            取消訂單
          </w-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import OrderBlock from './OrderBlock';

export default OrderBlock;
</script>

<style lang="scss" scoped>
@import 'OrderBlock';
</style>
